export * from './lib/match';
export * from './lib/apply-regex-list';



/** WEBPACK FOOTER **
 ** ./repos/syntaxhighlighter-match/index.js
 **/